module.exports = __webpack_public_path__ + "img/emptyPocket.3cfc9d0d.png";